var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2031 7.02515V6.36927C11.2031 5.53369 11.2031 3 7.83378 3C4.46451 3 4.46451 5.53369 4.46451 6.36927V7.02515C3.36838 7.26774 3 7.97754 3 9.51392V10.4124C3 12.389 3.61097 13 5.5876 13H10.08C12.0566 13 12.6676 12.389 12.6676 10.4124V9.51392C12.6676 7.97754 12.2992 7.26774 11.2031 7.02515ZM7.83378 10.9515C7.28572 10.9515 6.84549 10.5112 6.84549 9.96316C6.84549 9.41509 7.28572 8.97483 7.83378 8.97483C8.38185 8.97483 8.82208 9.41509 8.82208 9.96316C8.82208 10.5112 8.38185 10.9515 7.83378 10.9515ZM9.85535 6.92632H5.81222V6.36927C5.81222 5.0575 6.13567 4.34771 7.83378 4.34771C9.5319 4.34771 9.85535 5.0575 9.85535 6.36927V6.92632Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSmall);
export default __webpack_public_path__ + "static/media/lock-small.ffef371a1d49c5be39dc4f36ebd09e84.svg";
export { ForwardRef as ReactComponent };